import React from 'react';
import { Reveal } from './Reveal';
interface SectionHeadingProps {
  label: string;
  title: string;
  intro?: string;
  tone?: 'light' | 'dark';
  id?: string;
}
export function SectionHeading({
  label,
  title,
  intro,
  tone = 'light',
  id
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <Reveal className="max-w-3xl" data-id="element-66" data-mp="3jzdocopo5ue0">
      <div className="flex items-center gap-3" data-id="element-67" data-mp="3k0f8dionxr7v">
        <span className={`h-px w-8 ${dark ? 'bg-bronze-light' : 'bg-bronze'}`} aria-hidden="true" data-id="element-68" data-mp="bjtxtxgduq2n" />
        <p className={`text-sm font-medium ${dark ? 'text-bronze-light' : 'text-bronze'}`} data-id="element-69" data-mp="gjzrfj67qmnd">{label}</p>
      </div>
      <h2 id={id} className={`mt-4 font-serif text-4xl font-normal leading-[1.1] tracking-tight md:text-5xl ${dark ? 'text-paper' : 'text-ink'}`} data-id="element-70" data-mp="1tiry5d526t4">
        {title}
      </h2>
      {intro && <p className={`mt-5 text-lg leading-relaxed ${dark ? 'text-slate-light' : 'text-slate-text'}`} data-id="element-71" data-mp="uhwo0fko2t21">{intro}</p>}
    </Reveal>;
}